<script setup>
import { computed, ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import Cookies from 'js-cookie';

const route = useRoute();
const iframeRef = ref(null);
const isLoading = ref(true);

const dashboardUrl = computed(() => {
  const token =
    Cookies.get('cw_d_session_info') ||
    Cookies.get('access_token') ||
    Cookies.get('user_access_token') ||
    '';
  const accountId = route.params.accountId;
  return `/disputes-dashboard.html?token=${encodeURIComponent(token)}&account_id=${accountId}`;
});

const onIframeLoad = () => {
  isLoading.value = false;
};

onMounted(() => {
  // Fallback: clear loading after 8s even if load event doesn't fire
  setTimeout(() => {
    isLoading.value = false;
  }, 8000);
});
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template -->
  <div class="flex flex-col h-full w-full bg-n-background">
    <header
      class="flex items-center justify-between px-6 py-3 border-b border-n-strong"
    >
      <h1 class="text-lg font-medium text-n-slate-12">Disputes & Evidence</h1>
      <a
        href="/disputes-dashboard.html"
        target="_blank"
        rel="noopener"
        class="text-sm text-n-blue-text hover:underline"
      >
        Open in new tab
      </a>
    </header>
    <div class="relative flex-1">
      <div
        v-if="isLoading"
        class="absolute inset-0 flex items-center justify-center bg-n-background z-10"
      >
        <span class="text-sm text-n-slate-11">Loading disputes...</span>
      </div>
      <iframe
        ref="iframeRef"
        :src="dashboardUrl"
        class="w-full h-full border-0"
        @load="onIframeLoad"
      />
    </div>
  </div>
</template>
